import { ELOQUENT } from '../config/constants';

export function getAllCategories(query) {
    return ELOQUENT.Category.getAll(query);
}

export function getOneCategory(id) {
    return ELOQUENT.Category.getOne(id);
}

export function createCategory(data) {
    return ELOQUENT.Category.createOne(data);
}

export function deleteCategory(id) {
    return ELOQUENT.Category.deleteOne(id);
}

export function updateCategory(id, data) {
    return ELOQUENT.Category.updateOne(id, data);
}

export function createSubCategory(data) {
    return ELOQUENT.Category.createSubCategory(data);
}

export function updateSubCategory(id, data) {
    return ELOQUENT.Category.updateSubCategory(id, data);
}
